// @ts-nocheck
/* eslint-disable react/prop-types */
import React, { useMemo, useEffect,createContext,useContext } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import InputLabel from '@mui/material/InputLabel';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import InputBase from '@mui/material/InputBase';
import { styled, alpha } from '@mui/material/styles';
import { visuallyHidden } from '@mui/utils';
import SearchIcon from '@mui/icons-material/Search';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { Link, useLocation  } from 'react-router-dom';
//import Ts from "./TS.tsx";
import {useIntl  , FormattedMessage } from 'react-intl';
import ReactGA from "react-ga4";
import Refresh from './components/refresh';
import {LoginContext,LoadingContext} from '../Default';
import {
  MaterialReactTable,
  useMaterialReactTable,
  type MRT_ColumnDef,
} from 'material-react-table';
import {  colors } from '@mui/material';
//import { data, type Person } from './makeData';
import {type C2List}  from "./data/tdb_c2";
import './TS.css';
import Chip from '@mui/material/Chip';
import { MRT_Localization_JA } from 'material-react-table/locales/ja';
import { MRT_Localization_EN } from 'material-react-table/locales/en';
import {stix} from './data/tdb_c2.tsx';
import logo from '../../TIP_tate.svg';
import { Helmet } from 'react-helmet-async';

//import {RefreshContext} from './SearchResult';
// Google Analytics 測定 ID を入力して設定
ReactGA.initialize(process.env.REACT_APP_GA_KEY);
// const Item = styled(Paper)(({ theme }) => ({
//   backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
//   ...theme.typography.body2,
//   padding: theme.spacing(1),
//   textAlign: 'center',
//   color: theme.palette.text.secondary,
// }));
//export const RefreshContext = createContext();
const handleReady = () => {

};
const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(1),
    width: 'auto',
  },
}));
const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));
const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  width: '100%',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    [theme.breakpoints.up('sm')]: {
      width: '12ch',
      '&:focus': {
        width: '20ch',
      },
    },
  },
}));
const StyledBox = styled('div')(({ theme }) => ({
  alignSelf: 'center',
  width: '100%',
  height: 400,
  marginTop: theme.spacing(8),
  borderRadius: theme.shape.borderRadius,
  outline: '1px solid',
  boxShadow: '0 0 12px 8px hsla(220, 25%, 80%, 0.2)',
  backgroundImage: `url(${'/static/images/templates/templates-images/hero-light.png'})`,
  outlineColor: 'hsla(220, 25%, 80%, 0.5)',
  backgroundSize: 'cover',
  [theme.breakpoints.up('sm')]: {
    marginTop: theme.spacing(10),
    height: 700,
  },
  ...theme.applyStyles('dark', {
    boxShadow: '0 0 24px 12px hsla(210, 100%, 25%, 0.2)',
    backgroundImage: `url(${'/static/images/templates/templates-images/hero-dark.png'})`,
    outlineColor: 'hsla(210, 100%, 80%, 0.1)',
  }),
}));
const styles = (theme: { spacing: { unit: number; }; shape: { borderRadius: any; }; breakpoints: { up: (arg0: string) => any; }; transitions: { create: (arg0: string) => any; }; }) => ({
  root: {
  },
  textField: {
      marginLeft: theme.spacing.unit,
      marginRight: theme.spacing.unit,
      width: 200,
  },
  search: {
      position: 'relative',
      borderRadius: theme.shape.borderRadius,
      '&:hover': {
      },
      marginLeft: 0,
      width: '100%',
      [theme.breakpoints.up('sm')]: {
          marginLeft: theme.spacing.unit,
          width: 'auto',
      },
  },
  searchIcon: {
      width: theme.spacing.unit * 9,
      height: '100%',
      position: 'absolute',
      pointerEvents: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
  },
  inputRoot: {
      color: 'inherit',
      width: '100%',
  },
  inputInput: {
      paddingTop: theme.spacing.unit,
      paddingRight: theme.spacing.unit,
      paddingBottom: theme.spacing.unit,
      paddingLeft: theme.spacing.unit * 10,
      transition: theme.transitions.create('width'),
      width: '100%',
      [theme.breakpoints.up('sm')]: {
          width: 120,
          '&:focus': {
              width: 200,
          },
      },
  },
});

export default function Column() {
  const intl = useIntl();
  let locale;
  if(intl.locale == "ja"){
    locale = MRT_Localization_JA
  }else{
    locale = MRT_Localization_EN
  }
  const location = useLocation();
  const [category, setCategory] = React.useState(location.state!==null&&location.state.hasOwnProperty("category") ? location.state["category"] : "0");
  const [keyword, setKeyword] = React.useState(location.state!==null&&location.state.hasOwnProperty("keyword") ? location.state["keyword"] : "");
  //const [refreshKey, setRefreshKey] = React.useState(0);
  //const [isActive, setIsActive] = useState(false);
  //const [category] = React.useState(location.state["category"]);
  //const [keyword] = React.useState(location.state["keyword"]);
  const [posts,setPosts] = React.useState<Post[]>([]);
  const [postsSeo,setPostsSeo] = React.useState<Post[]>([]);
  const [postsSeo2,setPostsSeo2] = React.useState<Post[]>([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [open5, setOpen5] = React.useState(true);
  const {login,setLogain} = useContext(LoginContext);
  const {loading,setLoading} = useContext(LoadingContext);
  const [reload,setReload] = React.useState(0);
  const [keyword2,setKeyword2] = React.useState(location.state!==null&&location.state.hasOwnProperty("keyword") ? location.state["keyword"] : intl.formatMessage({ id: "langID00088" }));

  // const value = {
  //   refreshKey,
  //   setRefreshKey,
  // };

  const handleChange = (event:SelectChangeEvent) => {
    setCategory(event.target.value);
    
  }
  const handleChangeInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    setKeyword(event.target.value);
  }
  const reloadChange = () => {
    if(keyword==""){
      setKeyword2(intl.formatMessage({ id: "langID00088" }));
    }else{
      setKeyword2(keyword);
    }
    const i = reload+1;
    setReload(i);
  }

  const params = { // 渡したいパラメータをJSON形式で書く
      category: category,
      keyword: keyword
    };
  var getParams = new URLSearchParams(params);
   // TextfieldとButtonIconを合体させたコンポーネントの作成
 const AddButton = () => {
  const addButtonClick = () => {

    // document.getElementById("demo-form").submit();
        ReactGA.event({
      category: "Search Colmn Button",
      action: "Search Colmn Button",
      label: keyword, // Optional
    });
    //const aaa = document.getElementById("sc");
    //aaa?.click();
    reloadChange();
     //setRefreshKey(old => old + 1)
  };
    return (
    <IconButton onClick={() => addButtonClick()}>
      <SearchIcon />
    </IconButton>
  );
};
  //const {refreshKey, setRefreshKey} = useContext(RefreshContext);
    const resData = async (): Promise<Post[]> => {
    const url = process.env.REACT_APP_COLUMN_API_URL;
    try{
      let bodyData;
      if(keyword == ""){
      bodyData= {
      category: "13",
      keyword: keyword
    };
      }else if(keyword.indexOf("#") === 0){
        const keywordSub = keyword.replace("#","");
      bodyData= {
      category: "15",
      keyword: keywordSub
    };
      }else{
      bodyData= {
      category: "14",
      keyword: keyword
      };
      }

  var getParams = new URLSearchParams(params);
   const headers = new Headers({
            "Access-Control-Allow-Origin": process.env.REACT_APP_HOME_URL,
            'Access-Control-Allow-Credentials': 'true'
        });
  var params_str = params.toString();
  setLoading(true);
  return fetch(url , {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(bodyData)
    })
    .then((response) => {
      if (!response.ok ){
        setLoading(false);
        throw new Error('status is not 200');
      }
      return response.json();
    })
    .then(jsondata => {
      setLoading(false);
      return jsondata;
    })
    .catch(error => {
      setLoading(false);
    });;
    setLoading(false);
    }catch{
      setLoading(false);
    }
};
  //const {refreshKey, setRefreshKey} = useContext(RefreshContext);
    const resSeoData = async (): Promise<Post[]> => {
    const url = process.env.REACT_APP_SEO_API_URL;
    try{
      let bodyData;
      bodyData= {
      category: "24",
      keyword: "column"
      }

      

   var getParams = new URLSearchParams(params);
   const headers = new Headers({
            "Access-Control-Allow-Origin": process.env.REACT_APP_HOME_URL,
            'Access-Control-Allow-Credentials': 'true'
        });
  var params_str = params.toString();
  setLoading(true);
  return fetch(url , {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(bodyData)
    })
    .then((response) => {
      if (!response.ok ){
        throw new Error('status is not 200');
      }
      return response.json();
    })
    .then(jsondata => {
      return jsondata;
    })
    .catch(error => {
    });
    }catch{
    }
};
    const resSeoData2 = async (): Promise<Post[]> => {
    const url = process.env.REACT_APP_COLUMN_API_URL;
    try{
      let bodyData;
      bodyData= {
      category: "19",
      }

      

   var getParams = new URLSearchParams(params);
   const headers = new Headers({
            "Access-Control-Allow-Origin": process.env.REACT_APP_HOME_URL,
            'Access-Control-Allow-Credentials': 'true'
        });
  var params_str = params.toString();
  setLoading(true);
  return fetch(url , {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(bodyData)
    })
    .then((response) => {
      if (!response.ok ){
        throw new Error('status is not 200');
      }
      return response.json();
    })
    .then(jsondata => {
      return jsondata;
    })
    .catch(error => {
    });
    }catch{
    }
};


  useEffect(() => {
    (async function () {
      var res =[];
      const data = await resData();
      for(var i in data){
        if(data[i].ver !==999999){
          if(!res.some(member => member.id === data[i].id)){
            res.push(data[i]);
          }
        }
      }
      setPosts(res);
      setLoading(false);
    })();
   }, [reload]);

     useEffect(() => {
    (async function () {
      var res =[];
      const data = await resSeoData();
      setPostsSeo(data);
    })();
   }, []);

    useEffect(() => {
    (async function () {
      var res =[];
      const data = await resSeoData2();
      setPostsSeo2(data);
    })();
   }, []);

  const columns = useMemo<MRT_ColumnDef<C2List>[]>(
    //column definitions...
    () => [
      {
        accessorKey: 'ip',
        header: '',
        size: 50,
        grow: false,
        Cell: ({ cell ,row}) => (
        <div >
           <Box noWrap="true"
        sx={{
          display: 'flex',
          position: 'sticky',
          justifyContent: 'flex-start',
        }}
        
      >
          <Box noWrap
        sx={{
          display: 'flex',
          left: '10px',
          position: 'sticky',
          width: '100%',
          marginLeft: '30px',
          justifyContent: 'flex-start'
        }}
      >
                <img
                  height={90}
                  width={90}
                  src={cell.row.original.thumbnail}
                  loading="lazy"
                />
        <Box noWrap sx={{ textAlign: 'left',marginLeft: '40px',display: 'block' }} component="span" >
          <Typography noWrap variant="h4" noWrap="true" style={{ maxWidth: '1300px' }}    sx={{
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      WebkitLineClamp: '2',
      WebkitBoxOrient: 'vertical',
   }}>
            {(() => {
                    return <Button component={Link} title={cell.row.original.title} size="small"  fullWidth noWrap sx={{
      overflow: 'hidden',
      textOverflow: 'ellipsis',
   }} labelStyle={{paddingLeft: 0, paddingRight: 0}} style={{  overflow: "hidden",
  display: "block",
  mx: 'auto',height:"100%",color: 'black',fontSize: '0.8em',textOverflow: 'ellipsis',overflow: 'hidden'}} id={cell.row.original.title} to="/ColumnDetail"  state={{keyword:keyword,table:cell.row.original,bf:"nor"}} onClick=
         {e => {
                // e.keyCodeは常に0になる
                    ReactGA.event({
                      category: "Click Column Detail",
                      action: "Click Column Detail",
                      label: cell.row.original.title, // Optional
                    });

              }} >{cell.row.original.title}  </Button>;
            })()}
            </Typography>
          <Typography component='p' variant="h6" noWrap="true" style={{ maxWidth: '1200px',justifyContent: 'space-between'}} sx={{
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      WebkitLineClamp: '2',
      WebkitBoxOrient: 'vertical',
   }} >
            {(() => {
                const tags = [];
                for(let tag in cell.row.original.tag){
                if(tag==5){
                  tags.push(<br/>);
                }
                  tags.push(<Button component={Link}  size="small" style={{  flexWrap: 'wrap',overflowWrap:'break-word',fontSize: '1em' , color: 'black'}} id={cell.row.original.title}  onClick=
         {e => {
                // e.keyCodeは常に0になる
                setKeyword("#"+cell.row.original.tag[tag]);
                reloadChange();
                setKeyword2("#"+cell.row.original.tag[tag]);
                    ReactGA.event({
                      category: "Click Column Detail",
                      action: "Click Column Detail",
                      label: cell.row.original.title, // Optional
                    });

              }} >{"#"+cell.row.original.tag[tag]}  </Button>)
                }
                return tags;
            })()}
          </Typography>
        </Box>
      </Box>
            <Box  bottom="0px" sx={{ justifyContent: 'flex-end',bottom:'0px',position:'relative' }}>
            <Typography variant="h6" sx={{ justifyContent: 'flex-end',bottom:'0px',position:'absolute',right: '0px' }}>
              {cell.row.original.date}
            </Typography>
            </Box>
      </Box>

            </div>
        ),
      },
    ],
    [posts],
  );
  const data = posts
  const table = useMaterialReactTable({
    columns,
    data,
    defaultColumn: {
     // minSize: 1100,
    // width:"100%"
    },
    enableTopToolbar: false,
    enableClickToCopy: false,
    enableColumnActions: false,
    enableColumnDragging: false,
    enableColumnFilter: false,
    enableColumnOrdering: false,
    enableEditing: false,
    enableGlobalFilter: false,
    enableGrouping: false,
    enableHiding: false,
    enableResizing: false,
    paginationDisplayMode:'pages',
    enableSorting: false,
    autosizeColumns:"none",
    localization: locale,
    initialState: {
      density: 'compact',
      pagination: { pageIndex: 0, pageSize: 10 },
    },
    muiDetailPanelProps: () => ({
    }),
    //custom expand button rotation
    muiExpandButtonProps: ({ row, table }) => ({
      onClick: () => table.setExpanded({ [row.id]: !row.getIsExpanded() }), //only 1 detail panel open at a time
      sx: {

      },
    }),
  });


  return (

    <Box noWrap
      id="hero"
      sx={(theme) => ({
        //width: '100%',
        backgroundRepeat: 'no-repeat',
        backgroundImage:
          'radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 90%), transparent)',
        ...theme.applyStyles('dark', {
          backgroundImage:
            'radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 16%), transparent)',
        }),
      })}
    >
      <Container maxWidth="xl"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          pt: { xs: 0, sm: 13 },
          pb: { xs: 0, sm: 0 },
        }}
      >
        <Helmet>
                {(() => {
                  const tags = [];
                  for (let i in data) {
                    tags.push(<meta name="keywords" content={data[i].title} />)
                    for (let j in data[i].tag) {
                      tags.push(<meta name="keywords" content={data[i].tag[j]} />)
                    }
                  }
                  return tags;
                })()}
                {(() => {
                  const tags = [];
                  for (let i in postsSeo) {
                    tags.push(<meta name="keywords" content={postsSeo[i].keyword} />)
                  }
                  return tags;
                })()}
                {(() => {
                  const tags = [];
                  for (let i in postsSeo2) {
                    tags.push(<link rel="canonical" href={process.env.REACT_APP_HOME_URL + "/ColumnDetail?_id=" + postsSeo2[i]._id} />)
                    
                  }
                  return tags;
                })()}
        </Helmet>

            <InputLabel htmlFor="email-hero" sx={visuallyHidden} >
            </InputLabel>
            <Container maxWidth={false}>
            <TextField
              id="email-hero"
              hiddenLabel
              fullWidth
              variant="outlined"
              placeholder={intl.formatMessage({ id: "langID00086" })}
              //value={location.state["keyword"]}
              defaultValue={keyword}
              value={keyword}
              autoComplete= 'off'
              InputProps={{ endAdornment: <AddButton /> }}
              onChange={handleChangeInput}
              sx={{ height:60}}
              onKeyDown={e => {
                // e.keyCodeは常に0になる
                if (e.key === 'Enter') {
                  // エンターキー押下時の処理
                  // document.getElementById("demo-form").submit();
                      ReactGA.event({
                      category: "Search Button",
                      action: "Search Button",
                      label: keyword, // Optional
                });
                  reloadChange();
                  //const aaa = document.getElementById("sc");
                  //aaa?.click();
                   //setRefreshKey(old => old + 1);
                }
              }}
            />
            </Container>
            <Typography
            sx={{
              display: { xs: 'none', md: 'flex' },
              gap: 0.5,
              textAlign: 'center',
              color: 'text.secondary',
              width: { sm: '100%', md: '80%' },
            }}
          >

          </Typography>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={1}
            useFlexGap
            sx={{ pt: 2, width: { xs: '100%', sm: 'auto' } }}
          ></Stack>
            <Link hidden id="sc" to={"/search?"+getParams} state={{keyword:keyword,category:category}}>テキスト</Link>
      </Container>
    <input type="hidden" name="recaptcha_response" id="recaptchaResponse"></input>
    <Container maxWidth="xl"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
      <br/>
      <Container maxWidth="xl"
        sx={{
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        {keyword2 == keyword && <Typography variant="h5" gutterBottom>{keyword2}</Typography>}
        {keyword2 !== keyword && <Typography variant="h5" gutterBottom><FormattedMessage id = "langID00088"/></Typography>}
      </Container>
    <MaterialReactTable noWrap table={table}   />
    </Container>
    </Box>
  );
}